/** Registers the production service worker. In dev the worker is not built, so registration is skipped. */
export const registerServiceWorker = async (): Promise<void> => {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }
  await navigator.serviceWorker.register('/sw.js', { scope: '/' });
};
